import React from 'react'

import styled from 'styled-components/native'

import { ClientDetailsBenefitsSideBarSection } from '../../molecules/clientDetailsSideBarSection/ClientDetailsBenefitsSideBarSection'
import { ClientDetailsTherapySideBarSection } from '../../molecules/clientDetailsSideBarSection/ClientDetailsTherapySideBarSection'
import { ProfileCard } from '../../molecules/profileCard/ProfileCard'
import { Details } from '../../ui-models/messages/Details'

const Container = styled.View(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing['32px'],
}))

const SectionsContainer = styled.View(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing['32px'],
}))

const StyledProfileCard = styled(ProfileCard)({
  paddingBottom: 0,
})

export type ClientDetailsSideBarProps = {
  details: Details | null
  isLoading: boolean
  riskBadgeSlot?: React.ReactNode
}

export const ClientDetailsSideBar: React.FC<ClientDetailsSideBarProps> = ({ details, isLoading, riskBadgeSlot }) => {
  return (
    <Container>
      <StyledProfileCard
        isLoading={isLoading}
        clientDetails={details}
        withoutHorizontalOrientation
        withBorder={false}
        hasClientDetailsPageInformation={true}
        riskBadgeSlot={riskBadgeSlot}
      />
      {details && (
        <SectionsContainer>
          <ClientDetailsTherapySideBarSection details={details} />
          <ClientDetailsBenefitsSideBarSection details={details} />
        </SectionsContainer>
      )}
    </Container>
  )
}
